<template>
	<el-drawer :title="formData.id ? '营销短信详情' : '创建营销短信'" :visible.sync="visible" :wrapperClosable="false" size="auto"
		@closed="close" append-to-body>
		<div class="drawer-content">
			<el-form :model="formData" ref="formData" label-position="top" size="medium" :rules="rules">
				<el-form-item prop="name" >
					<span slot="label">短信名称：<small class="from-tip"><span
								class="el-icon-warning"></span>该名称不会发送给用户，仅用做展示</small></span>
					<el-input v-model="formData.name" placeholder="请填写短信名称" size="medium" :maxlength="40" show-word-limit>
					</el-input>
				</el-form-item>
				<el-form-item label="营销演出ID：">
					<el-input placeholder="请输入演出ID" v-model="activityId">
						<el-button slot="append" icon="el-icon-search" @click="searchActivity()">解析</el-button>
					</el-input>
					<table class="info-table"  width="100%" v-if="sActivityList">
					    <tr>
					        <th>演出ID</th>
					        <th>演出名称</th>
					    </tr>
					    <tr>
					        <td>{{sActivityList.id}}</td>
							<td>{{sActivityList.title}}</td>
					    </tr>
					</table>
					</el-table>
				</el-form-item>
				<el-form-item>
					<span slot="label">发送用户圈层：
						<el-button
								v-if="$utils.have('/smsMarketing/circle/info') && !canEdit"
								type="primary"
								size="small"
								icon="el-icon-refresh"
								:loading="loadLayerBtnloading"
								@click="loadLayer()"
								
								><span v-if="layerData.status == 0">更新计算中</span><span v-else>更新计算</span></el-button>
					</span>
						<el-checkbox label="0" border  v-model="layerType1" :true-label="1" :false-label="0">
							<div class="layer">
								<p class="layerTitle">用户圈层1
									<small class="color-danger fr" v-if="layerData =='' && !canEdit">解析营销演出后请更新计算人数</small>
									<el-button
										class="fr"
										v-if="layerData.status == 0 "
										type="text"
										size="small"
										icon="el-icon-loading"										
										>计算中</el-button>
									<span class="fr" v-if="layerData.status == 1 && !canEdit && !id">
										{{layerData.circle1TotalNum}}人
										<small><span class="ML10 color-blue">{{layerData.circle1TotalNum - layerData.circle1SendNum}}人未发送</span><span class="ML10 color-danger">{{layerData.circle1SendNum}}人已发送</span></small></span>
									<span class="ML10 color-danger fr" v-if="layerData.status == 1 && !canEdit && id">{{layerData.circle1TotalNum}}人已发送</span>
								</p>
								<div class="layerText">近3年内有过营销演出艺人历史专场演出<br>下单且下单城市和当前营销演出城市相同</div>
							</div>
						</el-checkbox><Br></Br>
						<el-checkbox label="1" border v-model="layerType2" :true-label="1" :false-label="0">
							<div class="layer">
								<p class="layerTitle">用户圈层2
									<small class="color-danger fr" v-if="layerData =='' && !canEdit">解析营销演出后请更新计算人数</small>
									<el-button
										class="fr"
										v-if="layerData.status == 0 "
										type="text"
										size="small"
										icon="el-icon-loading"										
										>计算中</el-button>
									<span class="fr" v-if="layerData.status == 1 && !canEdit && !id">
										{{layerData.circle2TotalNum}}人
										<small><span class="ML10 color-blue">{{layerData.circle2TotalNum - layerData.circle2SendNum}}人未发送</span><span class="ML10 color-danger">{{layerData.circle2SendNum}}人已发送</span></small></span>
										<span class="ML10 color-danger fr"  v-if="layerData.status == 1 && !canEdit && id">{{layerData.circle2TotalNum}}人已发送</span>
								</p>
								<div class="layerText">近3年内对艺人的历史演出有感兴趣的动作<br>（点击/浏览演出、收藏、关注、缺票登记）</div>
							</div>
						</el-checkbox><Br></Br>
						<el-checkbox label="2" border v-model="layerType3" :true-label="1" :false-label="0">
							<div class="layer">
								<p class="layerTitle">用户圈层3
									<small class="color-danger fr" v-if="layerData =='' && !canEdit">解析营销演出后请更新计算人数</small>
									<el-button
										class="fr"
										v-if="layerData.status == 0 "
										type="text"
										size="small"
										icon="el-icon-loading"										
										>计算中</el-button>
									<span class="fr" v-if="layerData.status == 1 && !canEdit && !id">
										{{layerData.circle3TotalNum}}人
										<small><span class="ML10 color-blue">{{layerData.circle3TotalNum - layerData.circle3SendNum}}人未发送</span><span class="ML10 color-danger">{{layerData.circle3SendNum}}人已发送</span></small></span>
										<span class="ML10 color-danger fr"  v-if="layerData.status == 1 && !canEdit && id">{{layerData.circle3TotalNum}}人已发送</span>
								</p>
								<div class="layerText">一年内购买相似演出的用户</div>
							</div>
						</el-checkbox>
				</el-form-item>
				<el-form-item prop="smsContent" >
					<span slot="label">短信内容：<small class="from-tip"><span
								class="el-icon-warning"></span> 短信内容：{秀动}+短信自定义内容+{了解查看演出详请戳}+{演出短链}+{拒收请回复R}</small></span>
					<el-input
					    v-model="formData.smsContent"
					    type="textarea"
					    placeholder="请输入短信内容"
					    maxlength="120"
					    show-word-limit
						
					></el-input>
					<small><span class="color-danger">{}中的内容为短信平台要求的固定格式，不支持编辑更改</span></small>
					<div v-if="formData.smsContent">
						<span slot="label">短信效果预览：</span>
						<div class="msgPreview">
							【秀动】{{formData.smsContent}} 了解查看演出详请戳： <span class="color-blue">{{formData.shortLink}}</span> 拒收请回复R
						</div>
					</div>
				</el-form-item>
				<el-form-item prop="tels">
					<span slot="label">指定手机号接收：<small class="from-tip"><span
								class="el-icon-warning"></span> 最多支持5个手机号，多个用英文逗号分隔</small></span>
					<el-input
					    v-model="formData.tels"
					    type="textarea"
					    placeholder="请输入手机号,多个用英文逗号分隔"						
					></el-input>
				</el-form-item>
				<el-form-item prop="circle1UserNum" v-show="layerType1 == 1 || canEdit">
					<span slot="label">用户圈层1发送人数：</span>
					<el-input-number style="width: 100%;" v-model="formData.circleUserNum1"  controls-position="right" :min="0" :max="layerData.circle1TotalNum - layerData.circle1SendNum" size="medium" placeholder="请填写发送人数" :disabled="layerData.circle1TotalNum - layerData.circle1SendNum ==0"></el-input-number>
				</el-form-item>
				<el-form-item prop="circle2UserNum" v-show="layerType2 == 1 || canEdit">
					<span slot="label">用户圈层2发送人数：</span>
					<el-input-number style="width: 100%;" v-model="formData.circleUserNum2"  controls-position="right" :min="0" :max="layerData.circle2TotalNum - layerData.circle2SendNum" size="medium" placeholder="请填写发送人数" :disabled="layerData.circle2TotalNum - layerData.circle2SendNum ==0"></el-input-number>
				</el-form-item>
				<el-form-item prop="circle3UserNum" v-show="layerType3 == 1 || canEdit">
					<span slot="label">用户圈层3发送人数：</span>
					<el-input-number style="width: 100%;" v-model="formData.circleUserNum3"  controls-position="right" :min="0" :max="layerData.circle3TotalNum - layerData.circle3SendNum" size="medium" placeholder="请填写发送人数" :disabled="layerData.circle3TotalNum - layerData.circle3SendNum == 0"></el-input-number>
				</el-form-item>
				<div class="autoSend">
					<el-form-item prop="sendType">
						<span slot="label">发送：</span>
						<el-radio-group v-model="formData.sendType"  @change="sendTypeChange()">
							<el-radio :label="1" border>提交后立即发送</el-radio>
							<el-radio :label="3" border>定时发送</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item prop="scheduledSendTime" >
						<div class="MT20">
							<el-date-picker v-model="formData.scheduledSendTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" format="yyyy-MM-dd HH:mm"  placeholder="选择发送时间"
								:picker-options="pickerOptions" v-if="formData.sendType == 3 " style="width: 100%;">
							</el-date-picker>
						</div>
					</el-form-item>
				</div>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="close()">关闭</el-button>
			<el-button type="primary" @click="submitForm()" :loading="btnLoading" v-if="layerData && layerData.status == 1 " :disabled="dataStatus == 0 ">提交</el-button>
		</div>
	</el-drawer>
</template>

<script>
const defaultFormData = {
	name:'',
	activityId:'',
	circleContent1:'近3年内有过营销演出艺人历史专场演出，下单且下单城市和当前营销演出城市相同',
	circleContent2:'近3年内对艺人的历史演出有感兴趣的动作，（点击/浏览演出、收藏、关注、缺票登记）',
	circleContent3:'90天内购买相似演出的用户',
	circleUserNum1:0,
	circleUserNum2:0,
	circleUserNum3:0,
	shortLink:'',
	smsContent:'',
	tels:'',
	scheduledSendTime:'',
	sendType: undefined
}
	export default {
		components: {

		},
		data() {
			const validateTels = (rule, value, callback) => {
			    if (value && !/^[,，0-9]+$/.test(value)) {
			        callback(new Error('请输入正确的手机号'));
			    } else {
			        callback();
			    }
			};
			const validateScheduledTime = (rule, value, callback) => {
			    if (this.formData.sendType == 3 && !value) {
			        callback(new Error('请选择发送时间'));
			    } else {
			        callback();
			    }
			};
			return {
				rules: {
				    name: { required: true, message: "请填写短信名称", trigger: 'change'},
				    smsContent: { required: true, message: "请填写短信内容", trigger: 'change'},
					sendType: { required: true, message: "请选择发送方式", trigger: 'change'},
					scheduledSendTime: [
					    { validator: validateScheduledTime, trigger: 'change' }
					],
					tels: [
					    {validator: validateTels, trigger: 'change'}
					],
				},
				visible: false,
				formData: {
					...defaultFormData
				},
				layerType1:'',
				layerType2:'',
				layerType3:'',
				sActivityLoading: false,
				sActivityList:null,
				activityId: '',
				layerData:[],
				loadLayerBtnloading:false,
				dataStatus:0,
				btnLoading:false,
				timer:null,
				id:'',
				canEdit:false
			};
		},
		computed: {
			pickerOptions() {
				return {
					disabledDate: (time) => {
						// 禁用今天之前的日期
						const today = new Date()
						today.setHours(0, 0, 0, 0)
						return time.getTime() < today.getTime()
					},
					selectableRange: this.getSelectableRange()
				}
			}
		},
		watch: {			
			'formData.scheduledSendTime'() {
				// 强制刷新 pickerOptions
				this.$forceUpdate()
			}
		},
		methods: {
			show(id) {
				this.id = id
				this.visible = true;				
				if( this.id ){
					this.getData()
					this.layerData.status = 1					
				}
				this.initDefaultTime()
			},
			close() {
				this.visible = false
				this.id = ''				
				this.dataStatus = 0
				this.canEdit = false
				if( !this.id ){
					this.formData = {...defaultFormData};
					this.activityId = ''
					this.layerData = []					
					this.sActivityList=null					
					this.layerType1 = ''
					this.layerType2 = ''
					this.layerType3 = ''
				}
			},
			padZero(num) {
				return num < 10 ? '0' + num : num.toString()
			},
			formatDateToString(date) {
			    const year = date.getFullYear()
			    const month = this.padZero(date.getMonth() + 1)
			    const day = this.padZero(date.getDate())
			    const hours = this.padZero(date.getHours())
			    const minutes = this.padZero(date.getMinutes())
			    const seconds = this.padZero(date.getSeconds())
			    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
			  },
			  initDefaultTime() {
				  if (this.formData.sendType == 3 ) {
					  const now = new Date()
					  const defaultTime = new Date(now.getTime() + 60 * 60 * 1000)
					  this.formData.scheduledSendTime = this.formatDateToString(defaultTime);
				  }			    
			  },
			getSelectableRange() {
				const now = new Date()
				// 如果还没有选择日期，或者选择的日期是今天，则限制时间
				if ( this.isToday(this.formData.scheduledSendTime)) {
					const minTime = new Date(now.getTime() + 60 * 60 * 1000)
					const startTime =
						`${this.padZero(minTime.getHours())}:${this.padZero(minTime.getMinutes())}:${this.padZero(minTime.getSeconds())}`
					return [
						[startTime, '23:59:59']
					]
				}
				// 如果选择的是未来日期，全天可选
				return [
					['00:00:00', '23:59:59']
				]
			},
			sendTypeChange(val) {
				// 清除发送方式和定时时间的验证状态
				this.$nextTick(() => {
					this.$refs.formData.clearValidate('sendType');
					this.$refs.formData.clearValidate('scheduledSendTime');
				});
				if (val == 1) {
					// 立即发送时清空定时时间
					this.formData.scheduledSendTime = '';
				} else {
					this.initDefaultTime()
				}
			},
			isToday(dateStr) {
				if (!dateStr) return true
				const date = new Date(dateStr)
				const today = new Date()
				return date.toDateString() === today.toDateString()
			},
			getData(){
				this.$request({
					url: '/smsMarketing/detail',
					method: 'get',
					params: {id:this.id}
				})
					.then((res) => {
						const { state, msg, result } = res.data;
						if (state == 1 && result) {	
							this.canEdit = true
							this.formData = result				
							this.activityId = this.formData.activityId							
							this.layerData.circle1TotalNum = result.circleUserTotalNum1
							this.layerData.circle2TotalNum = result.circleUserTotalNum2
							this.layerData.circle3TotalNum = result.circleUserTotalNum3
							this.layerData.status = 1
							this.layerType1 = result.circleUserNum1 > 0 ? 1 : 0
							this.layerType2 = result.circleUserNum2 > 0 ? 1 : 0
							this.layerType3 = result.circleUserNum3 > 0 ? 1 : 0
						} else {
							this.$message.error(msg || "没有找到相关数据,请重试");
						}
					})
					.catch(() => {
						this.$message.error("没有找到相关数据,请重试");
					})	
			},
			//搜索演出
			searchActivity() {				
				if( this.activityId == '' ){
					return this.$message.error('请输入演出ID');
				}
				this.$request({
					url: '/smsMarketing/activity/info',
					method: 'get',
					params: {activityId:this.activityId}
				})
					.then((res) => {
						const { state, msg, result } = res.data;
						if (state == 1) {							
							if (result ) {								
								this.sActivityList = result
								this.formData.shortLink = result.poster
							} else {
								this.activityId == ''
								this.$message.error(msg || '没有找到相关演出');
							}						
							
						} else {
							this.$message.error(msg || "没有找到相关演出,请重试");
						}
					})
					.catch(() => {
						this.$message.error("没有找到相关演出,请重试");
					})					
			},
			loadLayer(){
				var that = this
				
				if( !this.sActivityList  ){
					return this.$message.error('解析营销演出后才能计算！');
				}
				this.loadLayerFun()				
				this.timer = setInterval(() => {
				    if( this.dataStatus == 0 ){
				        that.loadLayerFun();		
				    }else{
				        clearInterval(this.timer);
				    }
				},1000)
			},
			//更新圈层
			loadLayerFun(){			
				this.loadLayerBtnloading = true
				this.$request({
					url: '/smsMarketing/circle/info',
					method: 'get',
					params: {activityId:this.sActivityList.id}
				})
					.then((res) => {
						const { state, msg, result } = res.data;
						if (state == 1) {							
							if (result ) {
								this.loadLayerBtnloading = false
								this.layerData = result
								if( this.layerData.status == 0 ){
									this.dataStatus = 0
								}else{
									this.dataStatus = 1
									this.layerData = result
								}
							} 
						} else {
							this.loadLayerBtnloading = false
							this.$message.error(msg || "更新失败,请重试");
						}
					})					
			},
			//表单提交
			submitForm(){
				
			    this.$refs["formData"].validate((valid) => {
			        if(valid){
						if( this.layerData && (this.layerData.circle1TotalNum - this.layerData.circle1SendNum == 0 ) && (this.layerData.circle2TotalNum - this.layerData.circle2SendNum == 0 ) && (this.layerData.circle3TotalNum - this.layerData.circle3SendNum == 0 )){
							return this.$message.error("可发送人数为0，不能创建！");	
						}					
						if( this.layerType1 == 0  && this.layerType2 == 0  && this.layerType3 == 0 && !this.id ){
							return this.$message.error("请选择发送用户圈层！");	
						}
						
						if( this.layerType1 == 1 && !this.formData.circleUserNum1  && (this.layerData.circle1TotalNum - this.layerData.circle1SendNum != 0 )  ){
							return this.$message.error("用户圈层1发送人数不能为空！");
						}
						if( this.layerType2 == 1 && !this.formData.circleUserNum2 && (this.layerData.circle2TotalNum - this.layerData.circle2SendNum != 0 )  ){
							return this.$message.error("用户圈层2发送人数不能为空！");
						}
						if( this.layerType3 == 1 && !this.formData.circleUserNum3 && (this.layerData.circle3TotalNum - this.layerData.circle3SendNum != 0 ) ){
							return this.$message.error("用户圈层3发送人数不能为空！");
						}
						this.formData.circleUserNum1 = this.layerType1 === 1 ? this.formData.circleUserNum1 : 0 ;
						this.formData.circleUserNum2 = this.layerType2 === 1 ? this.formData.circleUserNum2 : 0 ;
						this.formData.circleUserNum3 = this.layerType3 === 1 ? this.formData.circleUserNum3 : 0 ;
						
						
			            if(parseInt(this.formData.circleUserNum1 + this.formData.circleUserNum2 + this.formData.circleUserNum3 ) > 10000 ){
							return this.$message.error("用户圈层1发送人数+用户圈层2+用户圈层3发送人数不能超过10000！");
						}
						
						var numbers = this.formData.tels.split(',').map(num => num.trim()).filter(num => num);
						if( numbers.length > 5 ){
							return this.$message.error("最多只能输入5个手机号");
						}
						var telNum = false
						numbers.map(item => {
							const cleanNumber = item.replace(/\D/g, '');
							if( cleanNumber.length != 11 ) {
								telNum = true
							}
						})
						if( telNum === true ){
							return this.$message.error("请检查手机号是否输入正确！");
						}
			            this.btnLoading = true;
						const submitData = {
			                    ...this.formData,
							activityId:this.activityId,
							circleContent1:'近3年内有过营销演出艺人历史专场演出，下单且下单城市和当前营销演出城市相同',
							circleContent2:'近3年内对艺人的历史演出有感兴趣的动作，（点击/浏览演出、收藏、关注、缺票登记）',	
							circleContent3:'90天内购买相似演出的用户',	
			            };
						if (submitData.sendType == 1) {
						    submitData.scheduledSendTime = '';
						}
			            this.$request({
			                url: "/smsMarketing/add",
			                method: "POST",
			                data: submitData,
			            })
			            .then((res) => {
			                const { state, msg } = res.data;
			                if ( state == 1) {
			                    this.$emit('onUpdate');
			                    this.close();
								this.btnLoading = false;
			                } else {
			                    this.$message.error(msg || "请求失败");
								this.btnLoading = false;
			                }
			            })
			            
			        }else{
			            return false;
						
			        }
			    })
			}



		}
	};
</script>
<style lang="scss" scoped>
	.layer {
		width: 100%;
		height: 80px;
		text-align: left;
		.layerTitle{
			color:#000
		}
		.layerText{
			padding-top: 8px;
			font-size: 12px;
		}
	}
	
	::v-deep .el-checkbox.is-bordered.el-checkbox--medium {
		height: 80px;
		width: 100%;
	}
	::v-deep .el-checkbox.is-bordered.el-checkbox--medium .el-checkbox__label{
		width: 100%;
	}
	.msgPreview{
		padding: 10px;
		background-color:#EEE;
	}
	::v-deep .info-table{
		margin-top: 15px;
		font-size: 12px;
		padding: 0;
		line-height: 15px;
		text-align: center;
	}
	::v-deep .info-table td,::v-deep .info-table th{
	    border-right: 1px #E4E7ED solid;
		text-align: center;
		height: 15px;
	}
	::v-deep .el-form-item__label small{
		color:#E6A23C
	}
</style>